import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const AgentReqEdit = ({
  list,
  allCountry,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [company, setCompany] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [businessStreet, setBusinessStreet] = useState('');
  const [businessCountry, setBusinessCountry] = useState('');
  const [postalZip, setPostalZip] = useState('');
  const [businessPhone, setBusinessPhone] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [agentFindUsFrom, setAgentFindUsFrom] = useState('');
  const [typeOfBusiness, setTypeOfBusiness] = useState('');

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let formData = {
      firstName,
      lastName,
      company,
      businessStreet,
      businessCountry,
      postalZip,
      businessPhone,
      businessEmail,
      agentFindUsFrom,
      typeOfBusiness,
      status: false,
    };
    try {
      response = await axios({
        url: `/api/v1/private/agent/request/${id}`,
        method: 'put',
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // console.log('editForm response', response);

      list[editIndexNo] = response.data.data;
      setRefresh(!refresh);

      closeAddDialog();

      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      // console.log('e', error);
      handleSnakbarOpen(error.response.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setFirstName(editObj.firstName);
      setLastName(editObj.lastName);
      setCompany(editObj.company);
      setBusinessStreet(editObj.businessStreet);
      setBusinessCountry(editObj.businessCountry);
      setPostalZip(editObj.postalZip);
      setBusinessPhone(editObj.businessPhone);
      setBusinessEmail(editObj.businessEmail);
      setAgentFindUsFrom(editObj.agentFindUsFrom);
      setTypeOfBusiness(editObj.typeOfBusiness);
    }
  }, [editObj]);

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Agent' : 'Add Agent'}
        </Typography>
      </div>

      <form onSubmit={handleSubmit}>
        <TextField
          label="First name"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
        />

        <TextField
          label="Last Name"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />

        <TextField
          label="Company"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={company}
          onChange={e => setCompany(e.target.value)}
        />

        <TextField
          label="Business Email"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessEmail}
          onChange={e => setBusinessEmail(e.target.value)}
        />

        <TextField
          label="Business Street"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessStreet}
          onChange={e => setBusinessStreet(e.target.value)}
        />

        <TextField
          variant="outlined"
          select
          label="Business Country"
          size="small"
          fullWidth
          required
          value={businessCountry}
          onChange={e => setBusinessCountry(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((e, index) => (
            <MenuItem value={e.name} key={index}>
              <Box className={classes.inner}>
                <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.name}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Business Phone"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessPhone}
          onChange={e => setBusinessPhone(e.target.value)}
        />

        <TextField
          variant="outlined"
          select
          label="Agent Find Us From"
          size="small"
          fullWidth
          required
          value={agentFindUsFrom}
          onChange={e => setAgentFindUsFrom(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Advertisement">Advertisement</MenuItem>
          <MenuItem value="Social_Media">Social Media</MenuItem>
          <MenuItem value="Word_Of_Mouth">Word Of Mouth</MenuItem>
          <MenuItem value="GlobPay_Sales_Representative">GlobPay Sales Representative</MenuItem>
          <MenuItem value="GlobPay_Website">GlobPay Website</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Type Of Business"
          size="small"
          fullWidth
          required
          value={typeOfBusiness}
          onChange={e => setTypeOfBusiness(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Check_Casher">Check Casher</MenuItem>
          <MenuItem value="Convenience_Store">Convenience Store</MenuItem>
          <MenuItem value="Ethnic_Grocery">Ethnic Grocery</MenuItem>
          <MenuItem value="Grocery">Grocery</MenuItem>
          <MenuItem value="Liquor_Store">Liquor Store</MenuItem>
          <MenuItem value="Multi_Service">Multi Service</MenuItem>
          <MenuItem value="Pharmacy">Pharmacy</MenuItem>
          <MenuItem value="Port">Port</MenuItem>
          <MenuItem value="Biller">Biller</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AgentReqEdit;
